// Modules

// Constants
import { ERROR_MESSAGES } from "~constants/errorMessages"

// Components
import Input from "~app/Input"

interface Props {
  errors: any
  register: (_props: any) => any
  onChange: () => void
  getValues: () => any
}

const PasswordWithConfirmation = (props: Props) => {
  return (
    <>
      <Input
        name="password"
        type="password"
        label="Password"
        register={props.register("password", { required: true })}
        onChange={props.onChange}
        errorMessage={
          props.errors.password &&
          (props.errors.password?.message || ERROR_MESSAGES.FIELD_REQUIRED)
        }
      />

      <Input
        name="passwordConfirm"
        type="password"
        label="Repeat Password"
        register={props.register("passwordConfirm", {
          required: true,
          validate: value => {
            return (
              value === props.getValues().password ||
              ERROR_MESSAGES.PASSWORD_CONFIRM
            )
          },
        })}
        onChange={props.onChange}
        errorMessage={
          props.errors.passwordConfirm &&
          (props.errors.passwordConfirm?.message ||
            ERROR_MESSAGES.FIELD_REQUIRED)
        }
      />
    </>
  )
}

export default PasswordWithConfirmation
